'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _ = require('..');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventListItem = function (_Component) {
  (0, _inherits3.default)(EventListItem, _Component);

  function EventListItem(props) {
    (0, _classCallCheck3.default)(this, EventListItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EventListItem.__proto__ || (0, _getPrototypeOf2.default)(EventListItem)).call(this));

    _moment2.default.locale(props.locale);
    return _this;
  }

  (0, _createClass3.default)(EventListItem, [{
    key: 'render',
    value: function render() {
      if (this.props.children) {
        return this.props.children;
      }

      var _props = this.props,
          event = _props.event,
          placeholderImage = _props.placeholderImage;


      var date = this.props.featured ? (0, _moment2.default)(event.next_date) : (0, _moment2.default)(event.start_date);
      var query = {
        date: (0, _moment2.default)(event.start_date).format('YYYY-MM-DD_HH-mm-ss')
      };
      var itemAttributes = { className: 'EventListItem ' + this.props.layout + ' ' + this.props.size };

      if (this.props.layout === 'grid') {
        var imageUrl = event.photo_url || placeholderImage;
        if (imageUrl) {
          itemAttributes.style = { backgroundImage: 'url(' + imageUrl + ')' };
        }
      }

      var formattedDate = date.format(this.props.dateFormat.replace(/(<[^>]*>)/g, '[$1]')); // Escape HTML tags
      var timeAttributes = {};
      if (formattedDate !== date.format(this.props.dateFormat)) {
        timeAttributes.dangerouslySetInnerHTML = { __html: formattedDate };
      } else {
        timeAttributes.children = date.format(this.props.dateFormat);
      }

      function getListImage() {
        return placeholderImage || event.thumbnail_url;
      }

      return _react2.default.createElement(
        'article',
        itemAttributes,
        _react2.default.createElement(
          _reactRouter.Link,
          { to: { pathname: '/evenements/' + event.slug + '/' + event.id, query: query } },
          this.props.layout === 'list' && getListImage() && _react2.default.createElement('img', { alt: event.title, src: getListImage() }),
          _react2.default.createElement('time', (0, _extends3.default)({ dateTime: date.format('YYYY-MM-DDTHH:mm') }, timeAttributes)),
          _react2.default.createElement(
            'div',
            { className: 'info' },
            _react2.default.createElement(
              'h1',
              null,
              event.title
            ),
            event.venue && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'p',
                { className: 'venue' },
                event.venue.name
              )
            )
          )
        )
      );
    }
  }]);
  return EventListItem;
}(_react.Component);

EventListItem.propTypes = {
  /**
   * Child DOM elements provided as a custom item template.
   */
  children: _propTypes2.default.object,
  /**
   * [Moment](http://momentjs.com/docs/#/displaying/) format string used to display the date and
   * time. Can include markup.
   */
  dateFormat: _propTypes2.default.string,
  /**
   * Event object in the Caligram API format.
   */
  event: _propTypes2.default.object.isRequired,
  /**
   * Featured events have the `featured` class and use `next_date` instead of `start_date`.
   * This probably needs to be refactored as it doesn’t make much sense. ¯\_(ツ)_/¯
   */
  featured: _propTypes2.default.bool,
  /**
   * Format event to be displayed as part of a linear list or a grid.
   */
  layout: _propTypes2.default.oneOf(['list', 'grid']),
  /**
   * [Moment](https://momentjs.com/docs/#/i18n/) locale string
   */
  locale: _propTypes2.default.string,
  /**
   * Placeholder image to be used when the event has no image.
   */
  placeholderImage: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  /**
   * Display size of the event. Only used for the grid layout.
   */
  size: _propTypes2.default.oneOf(['small', 'normal'])
};
EventListItem.defaultProps = {
  dateFormat: 'H [h] mm',
  layout: 'list',
  locale: _.CaligramReact.config().locale,
  size: 'normal'
};
exports.default = EventListItem;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventListItem.js
// module id = 271
// module chunks = 0